/**
 * How a person is named where there is no room for more: the account menu,
 * the "who's here" avatars. Full name when there is one, else the part of the
 * email before the @.
 */
export function displayNameFor(name?: string | null, email?: string | null, fallback = 'User'): string {
  const clean = (name || '').trim();
  if (clean) return clean;
  return email?.split('@')[0] || fallback;
}

/** Two letters for an avatar: first and last word of the name, else the email's first two. */
export function initialsFor(name?: string | null, email?: string | null, fallback = 'U'): string {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length >= 2) return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
  if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
  return email?.substring(0, 2).toUpperCase() || fallback;
}
